<template>
  <div class="panel panel-default bf-people">
    <div class="panel-heading bf-people-heading">
      <div>
        <strong>People</strong>
        <div class="bf-people-subtitle">
          Find people you already follow or who follow you.
        </div>
      </div>

      <button
        class="button-unstyled bf-people-refresh"
        type="button"
        title="Refresh contacts"
        @click="refresh"
      >
        ↻
      </button>
    </div>

    <div class="bf-people-tabs">
      <button
        type="button"
        class="button-unstyled bf-people-tab"
        :class="{ active: activeTab === 'following' }"
        @click="setTab('following')"
      >
        Following
        <span class="bf-people-count">
          {{ following.length }}
        </span>
      </button>

      <button
        type="button"
        class="button-unstyled bf-people-tab"
        :class="{ active: activeTab === 'followers' }"
        @click="setTab('followers')"
      >
        Followers
        <span class="bf-people-count">
          {{ followers.length }}
        </span>
      </button>
    </div>

    <div class="bf-people-search-wrap">
      <input
        v-model="search"
        class="bf-people-search"
        type="search"
        autocomplete="off"
        placeholder="Search your contacts…"
      >
    </div>

    <div
      v-if="error"
      class="alert error bf-people-error"
    >
      {{ error }}
    </div>

    <div
      v-if="loading"
      class="bf-people-placeholder"
    >
      Loading people…
    </div>

    <div
      v-else-if="!activeUsers.length"
      class="bf-people-placeholder"
    >
      <template v-if="search">
        No matching people found.
      </template>
      <template v-else>
        No {{ activeTab }} accounts found.
      </template>
    </div>

    <div
      v-else
      class="bf-people-list"
    >
      <FollowCard
        v-for="user in activeUsers"
        :key="user.id"
        :user="user"
      />
    </div>
  </div>
</template>

<script src="./people.js"></script>

<style lang="scss">
@import '../../_variables.scss';

.bf-people {
  overflow: hidden;
}

.bf-people-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bf-people-heading strong {
  font-size: 1.1em;
}

.bf-people-subtitle {
  margin-top: 0.15em;
  opacity: 0.65;
  font-size: 0.85em;
  font-weight: normal;
}

.bf-people-refresh {
  font-size: 1.35em;
  padding: 0.35em 0.55em;
}

.bf-people-tabs {
  display: flex;
  border-bottom: 1px solid var(--border, rgba(255, 255, 255, 0.12));
}

.bf-people-tab {
  flex: 1 1 50%;
  padding: 0.85em 1em;
  text-align: center;
  border-bottom: 3px solid transparent;
  opacity: 0.7;
}

.bf-people-tab.active {
  opacity: 1;
  font-weight: 600;
  border-bottom-color: var(--accent, currentColor);
}

.bf-people-count {
  margin-left: 0.35em;
  opacity: 0.65;
}

.bf-people-search-wrap {
  padding: 0.85em;
  border-bottom: 1px solid var(--border, rgba(255, 255, 255, 0.08));
}

.bf-people-search {
  width: 100%;
  box-sizing: border-box;
  padding: 0.7em 0.85em;
}

.bf-people-list {
  display: flex;
  flex-direction: column;
}

.bf-people-list > * {
  border-bottom: 1px solid var(--border, rgba(255, 255, 255, 0.08));
}

.bf-people-list > *:last-child {
  border-bottom: 0;
}

.bf-people-placeholder {
  padding: 2em 1em;
  text-align: center;
  opacity: 0.7;
}

.bf-people-error {
  margin: 0.75em;
}

@media (max-width: 800px) {
  .bf-people-subtitle {
    display: none;
  }

  .bf-people-search-wrap {
    padding: 0.65em;
  }
}
</style>
